'use strict';

angular.module('atex.dam').controller('CommonListController', ['$rootScope', '$scope', '$window', 'ContentService',
  'DamService', '$q', '$state', 'configuration', 'DrawerService', 'DamActivityService', 'DamAclPermissionService' ,
  'DamNotificationService', 'UIConfigurationService', '$translate',
  'PrintService','TypeSetConfirmModal', 'DamListService', 'Application', 'ExportService',
  'ClipboardService', 'QueueSelectModal', '$injector', '$modal', 'ContentConfigurationService', '$http', 'DamSearchService',
function($rootScope, $scope, $window, ContentService, DamService, $q, $state, configuration, DrawerService,
         DamActivityService, DamAclPermissionService, DamNotificationService, UIConfigurationService, $translate,
         PrintService, TypeSetConfirmModal, DamListService, Application, ExportService,
         ClipboardService, QueueSelectModal, $injector, $modal, ContentConfigurationService, $http, DamSearchService) {
  var _translateTable;
  var ADMUtils;

  function changeLanguage() {
    _translateTable = undefined;
  }
  $rootScope.$on('dam:changeLanguage', function() {
    changeLanguage();
  });

  $scope.htmlToPlaintext = function(text) {
    return text ? String(text).replace(/<[^>]+>/gm, '') : '';
  };

  $scope.copyToClipboard = function () {
    if ($scope.selected === undefined || $scope.selected.length === 0) {
      return;
    }
    var clipboardInfo = {};
    clipboardInfo.data = [];
    var data = {
      id: 'contentid/' + $scope.selected[0].id,
      type: 'atex.dam.standard.Collection'
    };
    clipboardInfo.data.push(data);
    return ClipboardService.putInClipboard(clipboardInfo).then(function (response) {
      DamNotificationService.addNotification(atex.dam.Notification({
        type: 'success',
        message: $translate.getTranslationTable().__OPERATION_COMPLETED_SUCCESSFULLY__
      }), false);
    }, function (error) {
      DamNotificationService.addNotification(atex.dam.Notification({
        type: 'error',
        message: $translate.getTranslationTable().__ERROR_RETRIEVE_CLIPBOARD__
      }), true);
    });
  };

  $scope.isMobileDevice =function() {
    return DamService.isMobileDevice();
  };

  $scope.notifyPreview = function(entry, arrowKeys) {
    if (!DamService.isMobileDevice()) {
      $rootScope.$broadcast('dam:setPreviewingItem', entry, arrowKeys);
    }
  };

  $scope.isLocked = function(task) {
    return task._data.lockData && task._data.lockData.edit;
  };

  $scope.checkLock = function(item, n) {
    var deferred = $q.defer();
    DamActivityService.getLockData([item._data.id]).then(function(lockData){
      // In case of multi-selection use 1 sec timeout to avoid 'waterfall effect' on $scope.$watch('selected',...)
      var timeout = n > 0 ? 1000 : 1;
      setTimeout(function() {
        item._data.lockData = lockData;
        deferred.resolve();
      },  timeout);
    }).then(null, function(error) {
      deferred.resolve();
    });
    return deferred.promise;
  };

  $scope.checkLocks = function() {
    $scope.selected.forEach(function(entry) {
      $scope.checkLock(entry, $scope.selected.length);
    });
  };

  $scope.setPreviewingItem = function(item, $event, isThumbnail) {
    if (item === undefined) {
      $scope.clearSelection();
      $scope.notifyPreview(undefined);
      return;
    }

    $scope.checkLock(item);

    if (DamService.isMobileDevice()) {
      if ($scope.selected.length===1 && $scope.selected[0]===item) {
        $scope.selectSingle(item);
      } else {
        $scope.clearSelection();
        $scope.selected.push(item);
      }
      return;
    }

    // If ctrlKey (or Cmd on MAC) toggle selection to add/remove item
    // to/from selection
    if ($event.ctrlKey === true || $event.metaKey === true) {
      $scope.toggleSelection(item);
      return;
    }
    // If shiftKey and we have at least an item in the selection lets
    // select the intervall
    if ($event.shiftKey === true && $scope.selected.length > 0) {
      var startIndex = $scope.entries.indexOf($scope.selected[0]);
      var endIndex = $scope.entries.indexOf(item);
      $scope.clearSelection();
      $scope.selected.push($scope.entries[startIndex]);
      if (startIndex >= 0 && endIndex >= 0) {
        while (startIndex < endIndex) {
          startIndex++;
          $scope.selected.push($scope.entries[startIndex]);
        }
        while (startIndex > endIndex) {
          startIndex--;
          $scope.selected.push($scope.entries[startIndex]);
        }
      }
      if ($scope.selected.length <= 1) {
        $scope.notifyPreview(item);
      }
      return;
    }
    // Default single selection
    if ( ($scope.fullscreen) && ($scope.thumb) ) {
      return;
    }

    item.isNew=false;

    $scope.selectSingle(item);
  };

  $scope.$on("dam:updatedItem", function(event, asset) {
    if($state.current.name === 'list.versions') {
      return;
    }

    if (!asset || !asset.id || !$scope.entries) {
      return;
    }


    $scope.entries.forEach(function (entry, i) {
      if (entry.id === asset.id) {
        var variant = ($scope.physPage) ? 'ppage' : 'preview';
        ContentService.getContent({id: asset.id, variant: variant}).then(function (response) {
          atex.dam.AngularUtils.fixUrls(response.data);
          // For physical Page let's copy the data only when the version has changed
          // In order to avoid the logical pages popover (used to change the status) to close [max]
          if (!$scope.physPage || response.data.version !== entry._data.version) {
            angular.copy(response.data, entry._data);
          }
          // Not pretty, but the physical page view is not bound to this model, so we need to tell it to update separately
          if ($scope.physPage) {
            $rootScope.$broadcast("dam:physpage-updatedItem", entry);
          }
        });
      }
    });
  });

  $scope.isSelected = function (entry) {
    var selectClass = "";
    if ($scope.selected) {
      $scope.selected.forEach(function (selection, key) {
        if (typeof selection !== 'undefined' && selection.id === entry.id) {
          selectClass = "selected";
        }
      });
    }
    return selectClass;
  };

  $scope.selectSingle = function(item) {
    $scope.clearSelection();
    if (item !== undefined) {
      $scope.selected.push(item);
    }


    if ($state.current.name!=='list.collection' && DamService.isMobileDevice()) {
      // routeUI on preview
      if (!item.versionInfo) {
        $state.go('list.preview', { 'id' : item.id });
      } else {
        $state.go('list.versions.preview', { 'id' : item.id, 'version' : item.versionInfo.version});
      }
    } else {
      $scope.notifyPreview(item);
    }

  };

  $scope.toggleSelection = function(item) {
    if (item === undefined) {
      // Reset selection
      $scope.clearSelection();
      $scope.notifyPreview(undefined);
      return;
    }
    $scope.checkLock(item);
    var index = $scope.selected.indexOf(item);
    if (index < 0) {
      $scope.selected.push(item);
    } else {
      $scope.selected.splice(index, 1);
    }
    if ($scope.selected.length === 1) {
      $scope.notifyPreview($scope.selected[$scope.selected.length - 1]);
    } else if ($scope.selected.length === 0) {
      $scope.notifyPreview(undefined);
    }
  };

  $rootScope.$on("dam:selectNewDuplicatedItem", function(event, asset) {
    if ($rootScope.entryToaddInlistAfterDuplication) {
      $scope.entries.unshift($rootScope.entryToaddInlistAfterDuplication);
      $scope.entries.forEach(function(entry, index) {
        if (entry.id === $rootScope.entryToaddInlistAfterDuplication.id) {
          $scope.selectSingle(entry);
        }
      });
      $('#dam-list-list')[0].scrollTop = 0;
      $scope.justifyThumbs(true);
      delete $rootScope.entryToaddInlistAfterDuplication;
    }
  });

  $scope.toggleSelectAll = function() {
    if ($scope.selected.length !== $scope.entries.length) {
      $scope.entries.forEach(function(entry) {
        var index = $scope.selected.indexOf(entry);
        if (index < 0) {
          $scope.selected.push(entry);
        }
      });
    } else {
      $scope.clearSelection();
    }
    if ($scope.selected.length > 0) {
      $scope.notifyPreview($scope.selected[$scope.selected.length - 1]);
    } else {
      $scope.notifyPreview(undefined);
    }
  };

  $scope.canEdit = function () {
    $scope.showEdit = false;
    return DamListService.canEdit($scope.selected).then(function (canEdit) {
      $scope.showEdit = canEdit;
      return canEdit;
    });
  };

  $scope.printThis = function() {
    $window.atex.analytics('event', { e: 'printThis', d1: $scope.selected[0].id});
    $rootScope.$broadcast("dam:print", $scope.selected);
  };

  $scope.canPrint = function() {
    var print = false;

    if($scope.selected) {
      print = (($scope.selected.length > 0) && (!DamService.isMobileDevice()));
    }

    return print;
  };

  $scope.showRating = function() {
    return $scope.selected.length > 1;
  };

  $scope.edit = function() {
    var ids = atex.dam.AngularUtils.getIdsArray($scope.selected);

    DamAclPermissionService.hasWritePermissionEx($scope.selected).then(function (hasPermission) {
      if (!hasPermission) {
        DamNotificationService.addNotification(atex.dam.Notification({ type: 'error', message: $translate.getTranslationTable()._NO_EDIT_PERMISSION_LABEL_ }), true);
        return;
      }

      DamActivityService.getLockData(ids).then(function(lockData){
        var isCollection = $scope.selected[0] && $scope.selected[0]._data.aspects.contentData.data.objectType === 'collection';
        if (lockData.lockedBy && !isCollection) {
          DamActivityService.notifyItemLocked(lockData.getUserName());
        } else {
          if (!$scope.showEdit) {
            return;
          }

          if ($scope.selected[0]._data.aspects.contentData.data.objectType === 'collection') {
            $state.go('list.collection', { 'id' : $scope.selected[0]._data.id, 'preview': null });
          } else {
            DamActivityService.lock(ids).then(function(lockData){
              $state.go('list.edit', { ids : $scope.selected });
            });
          }
        }
      });
    });
  };

  $scope.$on("dam:itemDeleted", function(event, contentId) {
    if (!$scope.entries) {
      return;
    }
    $scope.entries.forEach(function(entry, index) {
      if (entry.id === contentId) {
        $scope.entries.splice(index, 1);
        // IMPORTANT: if we don't use the $parent scope we'll create a numFound on CommonListController
        // that is a child scope of DamListController [max]
        $scope.$parent.numFound--;
      }
    });
    $scope.selected.forEach(function(entry, index) {
      if (entry.id === contentId) {
        $scope.selected.splice(index, 1);
      }
    });
  });

  $scope.$on("dam:itemLogicalDeleted", function(event, item) {
    if (!item || !item.id || !$scope.entries) {
      return;
    }
    $scope.entries.forEach(function(entry) {
      if (entry.id === item.id) {
        angular.copy(item.data, entry._data);
      }
    });
    if ($rootScope.lastAdvQueryData && $rootScope.includeTrash!=="true") {
      $rootScope.$broadcast("dam:itemDeleted", item.id);
    }
  });

  $scope.$on("dam:hasRead", function(event, items) {
    items.forEach(function(item) {
      $rootScope.$broadcast('dam:updatedItem', item);
    });
  });

  $scope.$on("dam:loadConfigurationEnd", function (event) {
    UIConfigurationService.getSearchOptions().then(function (options) {
      if (options && options.hasOwnProperty('mark-as-read')) {
        var markAsReadOptions = options['mark-as-read'];
        if (markAsReadOptions.hasOwnProperty('enabled')) {
          $scope.hasReadEnabled = markAsReadOptions['enabled'];
        }
        if (markAsReadOptions.hasOwnProperty('mark-as-read-after-ms')) {
          $scope.hasReadSelectionTime = markAsReadOptions['mark-as-read-after-ms'];
        }
      }
    });
  });


  $scope.showDelete=false;
  $scope.showEdit=false;
  $scope.showWrite=false;
  $scope.showCreateJob=false;

  $scope.showUndelete=false;
  $scope.showPublish=false;
  $scope.showUnpublish=false;
  $scope.showEngage=false;
  $scope.showEngageEdit=false;
  $scope.showEngageCopy=false;
  $scope.showCopy=false;
  $scope.showDuplicate=false;
  $scope.showClearEngagements = false;
  $scope.showLinkToPrint = false;
  $scope.showSendToQueue = false;
  $scope.showSpike = false;
  $scope.showUnassignFromPage = false;
  $scope.showAssignToPage = false;
  $scope.showDupAssignToPage = false;
  $scope.showRebuildPage = false;
  $scope.showPlanRebuildPage = false;
  $scope.showPlanner = false;

  $scope.showSendToArchive = false;
  $scope.showRestrictContent = false;

  $scope.hasReadEnabled = false;
  $scope.hasReadSelectionTime = 3000;
  $scope.hasReadTimer = undefined;

  function selectionTimeExceeded(selectedValues) {
    switch(true) {
      default:
        if (!$scope.selected || !selectedValues) {
          break;
        } // no selections in either
        if (selectedValues.length === 0 || $scope.selected.length !== selectedValues.length) {
          break;
        } // different selections
        for (var i=0; i < $scope.selected.length; i++) {
          if ($scope.selected[i].id !== selectedValues[i].id) {
            break;
          }  // id's don't match
        }
        var userId = Application.currentUser.userId;
        if (!userId) {
          console.log("hasRead: Cannot get userId");
        }
        var storageKey = 'hasRead_' + userId;
        var storedItems = localStorage.getItem(storageKey);  // comma separated ids
        if (!storedItems) {
          storedItems = '';
        }
        var doWrite = false;
        for (var j = 0; j < selectedValues.length; j++) {
          var selectedValue = selectedValues[j];
          if (selectedValue && typeof(selectedValue) === 'object' && selectedValue.hasOwnProperty('id')) {
            var selectedId = selectedValue['id'];
            if (storedItems.indexOf(selectedId) > -1) {
              continue;
            }
            storedItems += ',' + selectedId;
            doWrite = true;
          }
        }
        if (doWrite) {
          while (storedItems.length > 1) {
            try {
              localStorage.setItem(storageKey, storedItems);
              break;
            } catch (e) {  // maybe storedItems is too long, retry store with smaller value
              var keyLength = selectedValues[0]['id'].length;
              if (storedItems.length > keyLength + 1) {
                storedItems = storedItems.slice(keyLength + 1);
              } else {
                // maybe no permission lets get out of here
                break;
              }
            }
          }
          $rootScope.$broadcast("dam:hasRead",selectedValues);
        }
    }

  }

  $scope.$watch('selected', function(values, oldValues) {
    $scope.checkSelection();
    // set timer -> call function with values
    if ($scope.hasReadEnabled) {
      if ($scope.hasReadTimer) {
        clearTimeout($scope.hasReadTimer);
      }
      $scope.hasReadTimer = setTimeout(selectionTimeExceeded.bind(null, values), $scope.hasReadSelectionTime);
    }
  },true);



  $scope.checkSelection = function() {
    $scope.checkLocks();
    $scope.canDelete();
    $scope.canEdit();
    $scope.canWrite();
    $scope.canCreateJob();

    $scope.canUndelete();
    $scope.canPublish();
    $scope.canUnpublish();
    $scope.canEngage();
    $scope.canEngageEdit();
    $scope.canEngageCopy();
    $scope.canCopy();
    $scope.canDuplicate();
    $scope.canClearEngagements();
    $scope.canLinkToPrint();
    $scope.canSendToQueue();
    $scope.canSpike();
    $scope.canDoPageOp();
    $scope.canShowPlanner();

    $scope.canSendToArchive();
    $scope.canRestrictContent();
    $scope.canUnlock();
  };

  $scope.canWrite = function () {
    $scope.showWrite = false;
    if ($scope.selected.length > 0) {
      DamAclPermissionService.hasWritePermissionEx($scope.selected).then(function (hasPermission) {
        $scope.showWrite = hasPermission;
      });
    }
  };

  $scope.canDelete = function() {
    $scope.showDelete = false;
    return DamListService.canDelete($scope.selected).then(function (canDelete) {
      $scope.showDelete = canDelete;
      return canDelete;
    });
  };

  $scope.canCreateJob = function() {
    $scope.showCreateJob = false;
    return DamListService.canCreateJob($scope.selected).then(function (canCreateJob) {
      $scope.showCreateJob = canCreateJob;
      return canCreateJob;
    });
  };


  $scope.exist = function (entry, path) {
    return (atex.onecms.ObjectUtils.getByPath(entry, path) !== undefined);
  };

  $scope.getText = function (entry, path) {
    var content = atex.onecms.ObjectUtils.getByPath(entry, path) || "";

    if (typeof content === "object" && typeof content.text === 'string') {
      content = content.text;
    }

    return content;
  };

  $scope.isHasReadEnabled = function() {
    return $scope.hasReadEnabled;
  };

  $scope.hasRead = function(entry) {

    var userId = Application.currentUser.userId;
    var id = entry.id;
    var storedItems = localStorage.getItem("hasRead_"+userId);
    if (storedItems) {
      return (storedItems.indexOf(id) > -1);
    }
    return false;
  };

  $scope.translate = function(message) {
    if ( message && _.isString(message) ) {
      if (!_translateTable) {
        _translateTable = $translate.getTranslationTable();
      }

      return (_translateTable && typeof _translateTable[message] !== 'undefined') ? (_translateTable[message]) : message;
    }

    return "";
  };

  $scope.canUndelete = function() {
    $scope.showUndelete = false;
    return DamListService.canUndelete($scope.selected).then(function (canUndelete) {
      $scope.showUndelete = canUndelete;
      return canUndelete;
    });
  };

  $scope.delete = function() {
    var ids = atex.dam.AngularUtils.getIdsArray($scope.selected);

    DamAclPermissionService.hasDeletePermissionEx($scope.selected).then(function (hasPermission) {
      if (!hasPermission) {
        DamNotificationService.addNotification(atex.dam.Notification({ type: 'error', message: $translate.getTranslationTable()._NO_DELETE_PERMISSION_LABEL_ }), true);
        return;
      }

      var locked = false;
      DamActivityService.lock(ids).then(function(responses){
        locked = true;
        var deletePromises = $scope.selected.map(function(item) {
          if (!(item._data.aspects.engagementAspect  && item._data.aspects.engagementAspect.data &&
              item._data.aspects.engagementAspect.data.engagementList &&
              item._data.aspects.engagementAspect.data.engagementList.length >0)) {
            // In case of real delete we need to delete also PublEvents
            ContentService.getContent({ id: item.id }).then(function(object) {
              if (object.data.aspects['p.InsertionInfo'].data.securityParentId === configuration.getTrashId()) {
                return ContentService.deleteContent({
                  id: object.id,
                  revision: object.revision
                }).then(function(responseInfo) {
                  $rootScope.$broadcast("dam:itemDeleted", item.id);
                }).then(null, function(error) {
                  if (!error.rootCause) {
                    console.log('ERROR: Deleting content:', error);
                  }
                  return undefined;
                });
              } else {
                var isTrashVisible = configuration.getTrashId() !== undefined;
                  return DamService.deleteContent(item._data.id, isTrashVisible).then(null, function(error) {
                  return undefined;
                });
              }
            }).then(null, function(error) {
              return undefined;
            });
          }
        });
        return $q.all(deletePromises);
      }).then(function(responses) {
        DamActivityService.unlock(ids);
      }).then(null, function(error) {
        if (locked) {
          DamActivityService.unlock(ids);
        }
      });
    });
  };

  $scope.undelete = function() {
    var ids = atex.dam.AngularUtils.getIdsArray($scope.selected);
    var locked = false;
    DamActivityService.lock(ids).then(function(responses){
      locked = true;
      var undeletePromises = $scope.selected.map(function(item) {
        if (item._data.aspects['p.InsertionInfo'].data.securityParentId !== configuration.getTrashId()) {
          return undefined;
        }
        return DamService.undeleteContent(item._data.id).then(null, function(error) {
          console.log('ERROR: Undeleting content');
          return undefined;
        });
      });
      return $q.all(undeletePromises);
    }).then(function(responses) {
      DamActivityService.unlock(ids);
    }).then(null, function(error) {
      if (locked) {
        DamActivityService.unlock(ids);
      }
    });
  };

  $scope.canCollect = function() {
    if ($scope.selected.length<=0) {
      return false;
    }
    var canCollect = false;
    $scope.selected.forEach(function(entry) {
      if (!canCollect && !DrawerService.contains(entry._data.id) && DrawerService.canCollectType(entry._data.aspects['contentData'].data.inputTemplate)) {
        canCollect = true;
        return true;
      }
    });
    return canCollect;
  };

  $scope.collect = function() {
    var ids = atex.dam.AngularUtils.getIdsArray($scope.selected);
    $window.atex.analytics('event', { e: 'collect', d1: ids});
    $scope.selected.forEach(function(entry) {
      if (!DrawerService.contains(entry._data.id) && DrawerService.canCollectType(entry._data.aspects['contentData'].data.inputTemplate)) {
        $rootScope.$broadcast("dam:addItemToCollector", entry._data.id);
      }
    });
  };

  $scope.canShowHistory = function() {
    return $scope.selected.length === 1;
  };

  $scope.showHistory = function() {
    $window.atex.analytics('event', { e: 'showHistory', d1: $scope.selected[0].id});
    if ($scope.selected.length>0) {
      $state.go('list.versions', { 'id' : $scope.selected[0].id });
    }
  };

  var createConfirmDlg = function() {
    var confirmModal = TypeSetConfirmModal.create({
      'confirmHeader': $translate.getTranslationTable().__TYPESET_CONFIRM_HEADER__,
      'confirmBody': $translate.getTranslationTable().__TYPESET_CONFIRM_BODY__,
      'mode': 'primary'
    });

    return confirmModal;
  };

  $scope.openPageTypeSet = function() {
    var ids = atex.dam.AngularUtils.getIdsArray($scope.selected);
    $window.atex.analytics('event', { e: 'openPageTypeSet', d1: ids});
    $scope.confirmModal = createConfirmDlg();
    $scope.confirmModal.show = true;

    $scope.confirmModal.then(function (confirmed) {
      if (confirmed === 'ok') {
        _.each($scope.selected, function (entry) {
          PrintService.openPageTypeSet(entry.id).then(function () {
            DamNotificationService.addNotification(atex.dam.Notification({
              type: 'success',
              message: $translate.getTranslationTable().__OPERATION_COMPLETED_SUCCESSFULLY__
            }), false);
          }).then(null, function (error) {
            var message = $translate.getTranslationTable().__GENERIC_ERROR_MSG__ + " (" + error.cause + ")";
            DamNotificationService.addNotification(atex.dam.Notification({type: 'error', message: message}), true);
          });
        });
      } else if (confirmed === 'cancel') {
        $scope.confirmModal.show = {};
        $scope.confirmModal.show = false;
      }
    });
  };

  $scope.canLinkToPrint = function() {
    var canLinkToPrint = false;

    if ($scope.selected.length>0) {
      $scope.selected.forEach(function (entry) {
        var contentData = entry._data.aspects.contentData.data;
        if (!canLinkToPrint && typeof contentData.objectType !== 'undefined') {
          var objectType = contentData.objectType;

          if (objectType === 'image' || objectType === 'photo' || objectType === 'article' || objectType === 'text') {
            canLinkToPrint = true;
          }
        }
      });
    }

    if ( $scope.showLinkToPrint !== canLinkToPrint ) {
      $scope.showLinkToPrint = canLinkToPrint;
    }
    return canLinkToPrint;
  };

  $scope.linkToPrint = function() {
    if (!ADMUtils) {
      ADMUtils = $injector.get("ADMUtils");
    }

    var toSend = [];
    angular.forEach($scope.selected, function (value) {
      var item = {};
      item.contentid = value._data.id;
      item.type = atex.onecms.AngularUtils.fromDeskTypeToHermesType(value._data.aspects.contentData.data.inputTemplate);
      item.inputTemplate = value._data.aspects.contentData.data.inputTemplate;
      item.name = encodeURIComponent(value._data.aspects.contentData.data.name);
      // Patch to handle custom articles and images
      if (item.type === "unknown") {
        var _type = atex.onecms.ObjectUtils.getByPath(value, '_data/aspects/contentData/data/_type');
        if (_type === 'atex.onecms.image') {
          item.type = "photo";
        } else if (_type === 'atex.onecms.article') {
          item.type = "article";
        }
      }
      toSend.push(item);
    });
    var drag = ADMUtils.DnDUtils.createDragUrl($scope.selected);

    if (drag) {
      PrintService.linkToPrint(toSend[0].contentid, atex.onecms.AngularUtils.createDragUrl(Application, toSend), 0, false).then(function (data) {
        DamNotificationService.addNotification(atex.dam.Notification({
          type: 'success',
          message: $translate.getTranslationTable().__OPERATION_COMPLETED_SUCCESSFULLY__
        }), false);

      }).then(null, function (error) {
        var message = $translate.getTranslationTable().__GENERIC_ERROR_MSG__ + " (" + error.cause + ")";
        DamNotificationService.addNotification(atex.dam.Notification({type: 'error', message: message}), true);
      });
    }
  };

  $scope.canSendToQueue = function() {
    var canSendToQueue = false;

    if ($scope.selected.length>0) {
      $scope.selected.forEach(function (entry) {
        var contentData = entry._data.aspects.contentData.data;
        if (!canSendToQueue && typeof contentData.objectType !== 'undefined') {
          var objectType = contentData.objectType;

          if (objectType === 'image' || objectType === 'photo' ||
            objectType === 'article' || objectType === 'text' || objectType === 'page' ) {
            canSendToQueue = true;
          }
        }
      });
    }

    if ( $scope.showSendToQueue !== canSendToQueue ) {
      $scope.showSendToQueue = canSendToQueue;
    }

    return canSendToQueue;
  };

  var sendToQueue = function( copy, spike ) {
    var ids = atex.dam.AngularUtils.getIdsArray($scope.selected);

    $window.atex.analytics('event', { e: copy ? 'copyToQueue': 'sendToQueue', d1: ids});
    $scope.sendToModal = QueueSelectModal.create({
      'mode': 'primary',
      'copy': !!copy,
      'spike': !!spike,
      'selected': $scope.selected
    });
    $scope.sendToModal.show = true;

    $scope.sendToModal.then(function (data) {
      $scope.sendToModal.show = false;
    });
  };

  $scope.copyToQueue = function() {
    sendToQueue( true, false );
  };

  $scope.sendToQueue = function() {
    sendToQueue( false, false );
  };

  $scope.canSpike = function() {
    var canSpike = $scope.canSendToQueue();

    if ( $scope.showSpike !== canSpike ) {
      $scope.showSpike = canSpike;
    }

    return canSpike;
  };

  $scope.spike = function() {
    sendToQueue( false, true );
  };

  var countAssigned = function() {
    var counts = {
      assigned: 0,
      unassigned: 0,
      page: 0,
      planRebuild: 0
    };

    if ($scope.selected.length>0) {
      $scope.selected.forEach(function (entry) {
        var contentData = entry._data.aspects.contentData.data;
        if (typeof contentData.objectType !== 'undefined') {
          var objectType = contentData.objectType;

          if (objectType === 'image' || objectType === 'photo' || objectType === 'article' || objectType === 'text') {
            var isAssigned = atex.onecms.ObjectUtils.getByPath(entry, '_data/aspects/atex.dam.standard.Publevents/data/publevents/0');

            if (isAssigned) {
              counts.assigned++;
            } else {
              counts.unassigned++;
            }
          }

          if ( objectType === 'page' ) {
            var publEvent = atex.onecms.ObjectUtils.getByPath(entry, '_data/aspects/atex.dam.standard.Publevents/data/publevents/0');

            if ( publEvent ) {
              counts.page++;
              if ( publEvent.nonPlan || publEvent.outOfDate ) {
                 counts.planRebuild++;
              }
            }
          }
        }
      });
    }

    return counts;
  };

  var buildEntries = function( params ) {
    var entries = [];
    var options = _.extend({
      assigned: false,
      unassigned: false,
      page: false,
      planRebuild: false
    }, params);

    if ($scope.selected.length>0) {
      $scope.selected.forEach(function (entry) {
        var contentData = entry._data.aspects.contentData.data;
        var type = atex.onecms.AngularUtils.fromDeskTypeToHermesType(contentData.inputTemplate);
        // Patch to handle custom articles and images
        if (type === "unknown") {
          if (contentData._type === 'atex.onecms.image') {
            type = "photo";
          } else if (contentData._type === 'atex.onecms.article') {
            type = "article";
          }
        }
        if ( type === 'image' || type === 'photo' || type === 'article' || type === 'text' ) {
          var isAssigned = atex.onecms.ObjectUtils.getByPath(entry, '_data/aspects/atex.dam.standard.Publevents/data/publevents/0');

          if ( (options.assigned && isAssigned) || (options.unassigned && !isAssigned) ) {
            entries.push({
              contentid: entry._data.id,
              type: type,
              inputTemplate: contentData.inputTemplate,
              name: encodeURIComponent(contentData.name)
            });
          }
        }

        if ( type === 'page' ) {
          var publEvent = atex.onecms.ObjectUtils.getByPath(entry, '_data/aspects/atex.dam.standard.Publevents/data/publevents/0');

          if ( publEvent ) {
            if ( options.page || ( options.planRebuild && (publEvent.nonPlan || publEvent.outOfDate ) ) ) {
              var pageId = atex.onecms.ObjectUtils.getByPath(entry, '_data/aspects/atex.print.Page/data/pageId');

              entries.push({
                contentid: pageId ? pageId : entry._data.id,
                type: type,
                inputTemplate: contentData.inputTemplate,
                name: encodeURIComponent(contentData.name)
              });
            }
          }
        }
      });
    }

    return entries;
  };

  var doPageAction = function( action, entries ) {
    if ( entries && entries.length > 0 ) {
      var contentOptions = {
        subType: action,
        contentData: atex.onecms.AngularUtils.createDragUrl(Application, entries)
      };

      if ( DamListService.hasAnchor() ) {
        contentOptions.contentId = DamListService.getAnchor().contentId;
      } else {
        contentOptions.contentId = entries[0].contentid;
      }

      if ( PrintService && PrintService.getPrintSystem().usePrintSystem ) {
        PrintService.content(contentOptions).then(function (response) {
          DamNotificationService.addNotification(atex.dam.Notification({
            type: 'success',
            message: $scope.translate('__OPERATION_COMPLETED_SUCCESSFULLY__')
          }), false);
        }).then(undefined, function (error) {
          var message = $scope.translate('__GENERIC_ERROR_MSG__') + " (" + error.cause + ")";
          DamNotificationService.addNotification(atex.dam.Notification({type: 'error', message: message}), true);
        });
      }
    }
  };

  $scope.canDoPageOp = function() {
    var canUnassignFromPage = false;
    var canAssignToPage = false;
    var canDupAssignToPage = false;
    var canRebuildPage = false;
    var canPlanRebuildPage = false;

    var counts = countAssigned();

    if (DamListService.hasAnchor()) {
      if (counts.assigned > 0) {
        canUnassignFromPage = true;
      }

      if (counts.unassigned > 0 && counts.assigned === 0) {
        canAssignToPage = true;
      }

      if (counts.unassigned > 0 || counts.assigned > 0) {
        canDupAssignToPage = true;
      }
    }

    if (counts.page > 0) {
      canRebuildPage = true;
    }

    if (counts.planRebuild > 0) {
      canPlanRebuildPage = true;
    }

    if ( $scope.showRebuildPage !== canRebuildPage ) {
      $scope.showRebuildPage = canRebuildPage;
    }

    if ( $scope.showPlanRebuildPage !== canPlanRebuildPage ) {
      $scope.showPlanRebuildPage = canPlanRebuildPage;
    }

    if ( $scope.showUnassignFromPage !== canUnassignFromPage ) {
      $scope.showUnassignFromPage = canUnassignFromPage;
    }

    if ( $scope.showAssignToPage !== canAssignToPage ) {
      $scope.showAssignToPage = canAssignToPage;
    }

    if ( $scope.showDupAssignToPage !== canDupAssignToPage ) {
      $scope.showDupAssignToPage = canDupAssignToPage;
    }
  };

  $scope.unassignFromPage = function() {
    if ( DamListService.hasAnchor() ) {
      var entries = buildEntries({
        assigned: true,
        unassigned: false
      });

      doPageAction( 'unassignFromDoc', entries );
    }
  };

  $scope.assignToPage = function() {
    if ( DamListService.hasAnchor() ) {
      var entries = buildEntries( {
        assigned: false,
        unassigned: true
      });

      doPageAction( 'assignToDoc', entries );
    }
  };

  $scope.dupAssignToPage = function() {
    if ( DamListService.hasAnchor() ) {
      var entries = buildEntries({
        assigned: true,
        unassigned: true
      });

      if (!_.isEmpty(entries)) {
        var toDup = [];

        entries.forEach(function (entry) {
          toDup.push(entry.contentid);
        });

        DamService.duplicate(toDup).then(function (contents) {
          contents.forEach(function (content, idx) {
            entries[idx].contentid = content;
          });

          doPageAction( 'assignToDoc', entries );
        });
      }
    }
  };

  $scope.rebuildPage = function() {
      var entries = buildEntries( {
        page: true
      });
      $window.atex.analytics('event', { e: 'rebuildPage', d1: entries});
      doPageAction( 'rebuildPage', entries );
  };

  $scope.planRebuildPage = function() {
    var entries = buildEntries( {
      planRebuild: true
    });

    doPageAction( 'planRebuild', entries );
  };

 $scope.canShowPlanner = function() {
   var canShowPlanner = false;

   if ($scope.selected.length>0) {
     $scope.selected.forEach(function (entry) {
       if (!canShowPlanner && entry._data.aspects['contentData'].data._type === 'atex.dam.standard.Page') {
         canShowPlanner = true;
       }
     });
   }

   if ( $scope.showPlanner !== canShowPlanner ) {
     $scope.showPlanner = canShowPlanner;
   }

   return canShowPlanner;
 };

 $scope.loadPlanView = function() {
   if ($scope.selected.length>0) {
     var ids = atex.dam.AngularUtils.getIdsArray($scope.selected);
     $window.atex.analytics('event', { e: 'loadPlanView', d1: ids});
     $rootScope.$broadcast('dam:loadPlanView', $scope.selected);
   }
 };

 $scope.canUnlock = function() {
   $scope.showUnlock = false;
   return DamListService.canUnlock($scope.selected).then(function (canUnlock) {
     $scope.showUnlock = canUnlock;
     return canUnlock;
   });
 };

 $scope.unlock = function() {
   var ids = atex.dam.AngularUtils.getIdsArray($scope.selected);
   $window.atex.analytics('event', { e: 'unlock', d1: ids});
   if ($scope.selected.length>0) {
     var promises = $scope.selected.map(function (item) {
       return DamListService.canUnlock([item]).then(function(canUnlock){
         if (canUnlock) {
           return item;
         }
       });
     });
     $q.all(promises).then(function (results) {
       var deletions = [];
       var _promises = results.map(function (item) {
         if (item) {
           var lockData = atex.onecms.ObjectUtils.getByPath(item || {}, '_data/lockData');
           if (item._data.aspects.contentData.data.objectType === "collection" && item._data.aspects.contentData.data.contents.length > 0){
             item._data.aspects.contentData.data.contents.forEach(function(content) {
               DamActivityService.removeActivity(content.replace("contentid/",""), lockData.lockedBy, lockData.app).then(function(){
                 deletions.push(content);
               });
             });
           }
           return DamActivityService.removeActivity(item.id, lockData.lockedBy, lockData.app).then(function(){
             deletions.push(item);
           });
         }
       });
       $q.all(_promises).then(function (results) {
         // Perform all the deletes at once to not overload the watch 'selected'
         deletions.forEach(function(item) {
           if (item._data){
             delete item._data.lockData;
           }
         });
       });
     });
   }
 };

 function clearEngagePromise (item) {
    return DamService.clearEngage(item._data.id).then(null, function(error) {
      console.log('ERROR: removing enagagement');
      return undefined;
    });
  }


 $scope.clearEngage = function() {
   var ids = atex.dam.AngularUtils.getIdsArray($scope.selected);
   var locked = false;
   DamActivityService.lock(ids).then(function(responses){
     locked = true;

     var chain = $q.when();
     $scope.selected.forEach(function (el) {
       chain = chain.then(clearEngagePromise(el));
     });
     return $q.all(chain);
   }).then(function(responses) {
     DamActivityService.unlock(ids);
   }).then(null, function(error) {
     if (locked) {
       DamActivityService.unlock(ids);
     }
   });
 };

 $scope.canPublish = function() {
   $scope.showPublish = false;
   return DamListService.canPublish($scope.selected).then(function (canPublish) {
     $scope.showPublish = canPublish;
     return canPublish;
   });
 };

 $scope.canUnpublish = function() {
   $scope.showUnpublish = false;
   return DamListService.canUnpublish($scope.selected).then(function (canUnpublish) {
     $scope.showUnpublish = canUnpublish;
     return canUnpublish;
   });
 };

 $scope.canEngage = function() {
   $scope.showEngage = false;
   return DamListService.canEngage($scope.selected).then(function (canEngage) {
     $scope.showEngage = canEngage;
     return canEngage;
   });
 };

 $scope.canEngageEdit = function() {
   $scope.showEngageEdit = false;
   return DamListService.canEngageEdit($scope.selected).then(function (canEngageEdit) {
     $scope.showEngageEdit = canEngageEdit;
     return canEngageEdit;
   });
 };

 $scope.canEngageCopy = function() {
   $scope.showEngageCopy = false;
   return DamListService.canEngageCopy($scope.selected).then(function (canEngageCopy) {
     $scope.showEngageCopy = canEngageCopy;
     return canEngageCopy;
   });
 };

 $scope.canCopy = function() {
   $scope.showCopy = false;
   return DamListService.canCopy($scope.selected).then(function (canCopy) {
     $scope.showCopy = canCopy;
     return canCopy;
   });
 };

 $scope.canDuplicate = function() {
   $scope.showDuplicate = false;
   return DamListService.canDuplicate($scope.selected).then(function (canDuplicate) {
     $scope.showDuplicate = canDuplicate;
     return canDuplicate;
   });
 };

 $scope.canClearEngagements = function() {
   $scope.showClearEngagements = false;
   return DamListService.canClearEngagements($scope.selected).then(function (canClearEngagements) {
     $scope.showClearEngagements = canClearEngagements;
     return canClearEngagements;
   });
 };

  $scope.canSendToArchive = function() {
    $scope.showSendToArchive = false;
    return DamListService.canSendToArchive($scope.selected).then(function (canSendToArchive) {
      $scope.showSendToArchive = canSendToArchive;
      return canSendToArchive;
    });
  };

  $scope.canRestrictContent = function() {
    $scope.showRestrictContent = false;
    return DamListService.canRestrictContent($scope.selected).then(function (canRestrictContent) {
      $scope.showRestrictContent = canRestrictContent;
      return canRestrictContent;
    });
  };

  $scope.exportToArchive = function() {
    ExportService.export($scope.selected, "p.DamImage").then(function() {
      DamNotificationService.addNotification(atex.dam.Notification({
        type: 'success',
        message: $translate.getTranslationTable().__OPERATION_COMPLETED_SUCCESSFULLY__
      }), false);
    });
  };

  $scope.restrictContent = function() {
    if ($scope.selected !== undefined){
      return ContentConfigurationService.getConfiguration({id: 'atex.WFStatusList'}).then(function(response){
        $scope.WFStatusList = atex.onecms.ObjectUtils.getByPath(response, 'data/aspects/contentData/data/status');
        $scope.restrictedStatus =  $scope.WFStatusList.find(function(status) {
          return status.statusID === "restricted";
        });
        return ContentService.getContent({id: 'dam.assets.restricted.d'}).then(function (content) {
          return ContentService.getContent({ id: $scope.selected[0].id }).then(function(object) {
            object.data.aspects["p.InsertionInfo"].data.securityParentId = content.id;
            object.data.aspects["p.InsertionInfo"].data.insertParentId = content.id;
            object.data.aspects["p.InsertionInfo"].data.associatedSites = [];
            object.data.aspects["atex.WFContentStatus"].data.status = JSON.parse(angular.toJson($scope.restrictedStatus));
            var updateInfo = {
              id: object.id,
              data:object.data,
              revision: object.revision
            };
            return ContentService.updateContent(updateInfo).then(function(object) {
              return DamNotificationService.addNotification(atex.dam.Notification({
                type: 'success',
                message: $translate.getTranslationTable().__OPERATION_COMPLETED_SUCCESSFULLY__
              }), false);
            });
          });
        });
      });
    }
  };


  $scope.unRestrictContent = function() {
    if ($scope.selected !== undefined){
      return ContentConfigurationService.getConfiguration({id: 'atex.WFStatusList'}).then(function(response){
        $scope.WFStatusList = atex.onecms.ObjectUtils.getByPath(response, 'data/aspects/contentData/data/status');
        $scope.restrictedStatus =  $scope.WFStatusList.find(function(status) {
          return status.statusID === "82";
        });
        return ContentService.getContent({id: 'dam.assets.production.d'}).then(function (content) {
          return ContentService.getContent({ id: $scope.selected[0].id }).then(function(object) {
            object.data.aspects["p.InsertionInfo"].data.securityParentId = content.id;
            object.data.aspects["p.InsertionInfo"].data.insertParentId = content.id;
            object.data.aspects["atex.WFContentStatus"].data.status = JSON.parse(angular.toJson($scope.restrictedStatus));
            var updateInfo = {
              id: object.id,
              data:object.data,
              revision: object.revision
            };
            return ContentService.updateContent(updateInfo).then(function(object) {
              return DamNotificationService.addNotification(atex.dam.Notification({
                type: 'success',
                message: $translate.getTranslationTable().__OPERATION_COMPLETED_SUCCESSFULLY__
              }), false);
            });
          });
        });
      });
    }
  };

  $scope.sendToArchive = function() {
    var exportOnSendToArchive = configuration.getExportOnSendToArchive();
    if (exportOnSendToArchive) {
      return $scope.exportToArchive();
    }
    DamService.getUserDomains().then(function(domain) {
      $scope.selected.map(function (entry) {
        var contentData = entry._data.aspects.contentData.data;
        if (typeof contentData.objectType !== 'undefined') {
          return ContentService.getContent({id: entry.id}).then(function (object) {
            // Set Archive flags!
            if (contentData.objectType === 'image') {
              object.data.aspects.contentData.data.inputTemplate = 'p.DamImage';
            } else if (contentData.objectType === 'video') {
              object.data.aspects.contentData.data.inputTemplate = 'p.DamVideo';
            } else if (contentData.objectType === 'article') {
              object.data.aspects.contentData.data.inputTemplate = 'p.DamArticle';
            }
            var partitionDimensions = _.where(object.data.aspects["atex.Metadata"].data.metadata.dimensions, {"id": "dimension.partition"});
            if (partitionDimensions && partitionDimensions[0] && partitionDimensions[0].entities && partitionDimensions[0].entities[0]) {
              if (domain && domain.archivePartition) {
                partitionDimensions[0].entities[0].id = domain.archivePartition.id;
                partitionDimensions[0].entities[0].name = domain.archivePartition.name;
              } else {
                partitionDimensions[0].entities[0].id = 'archive';
                partitionDimensions[0].entities[0].name = 'archive';
              }
            }
            var updateInfo = {
              id: object.id,
              data: object.data,
              revision: object.revision
            };
            return ContentService.updateContent(updateInfo).then(function (object) {
              entry._data.aspects.contentData.data.inputTemplate = object.data.aspects.contentData.data.inputTemplate;
              var _partitionDimensions = _.where(entry._data.aspects["atex.Metadata"].data.metadata.dimensions, {"id": "dimension.partition"});
              if (_partitionDimensions && _partitionDimensions[0] && _partitionDimensions[0].entities && _partitionDimensions[0].entities[0]) {
                _partitionDimensions[0].entities[0].id = 'archive';
                _partitionDimensions[0].entities[0].name = 'archive';
              }
              DamNotificationService.addNotification(atex.dam.Notification({
                type: 'success',
                message: $translate.getTranslationTable().__OPERATION_COMPLETED_SUCCESSFULLY__
              }), false);
              return object;
            }).then(null, function (error) {
              var message = $scope.translate('__GENERIC_ERROR_MSG__') + " (" + error.cause + ")";
              DamNotificationService.addNotification(atex.dam.Notification({type: 'error', message: message}), true);
            });
          });
        }
      });
    });
  };

  $scope.presentChangeStatusModal = function(ids) {
    if (!(ids instanceof Array)) {
      var _id = atex.dam.AngularUtils.removePrefix(ids);
      ids = [_id.trim()];
    }
    DamActivityService.lock(ids).then(function(lockData) {
      var changeStatusScope = $rootScope.$new(true);
      changeStatusScope.ids = ids;
      var modal = $modal({
        show : true,
        scope : changeStatusScope,
        template : 'views/dam-change-status-modal.html',
        modalClass : 'dam-modal-change-status confirm-modal ng-cloak',
        backdrop : 'static',
        keyboard : false
      });
      var destroyModal = function() {
        modal.then(function(modalEl) {
          modalEl.on('hidden.bs.modal', function() {
            changeStatusScope.$destroy();
            angular.element(this).remove();
          });
          modalEl.modal('hide');
        });
      };
      changeStatusScope.doCancel = function() {
        DamActivityService.unlock(ids);
        destroyModal();
      };
      changeStatusScope.doOk = function(data, status) {
        DamActivityService.unlock(ids);
        (data || []).forEach(function(updated) {
          $rootScope.$broadcast('dam:updatedItem', {'id': updated.id, 'status': status});
        });
        destroyModal();
      };
    });
  };

  $scope.invokeJS = function(button) {

    /*jslint evil: true */
    var fn = new Function(button.javascript);



    var ids = atex.dam.AngularUtils.getIdsArray($scope.selected);

    var locked = false;

    DamActivityService.lock(ids).then(function(lockData) {

      locked = true;
      var updatePromises=[];

      ids.forEach(function(id) {
        var transferInfo = { id: id };
        var promise = ContentService.getContent(transferInfo).then(function(response) {
          var param = {
            "$http": $http,
            "data" : response.data
          };
          try {
            fn.call(param);
          } catch (e) {
            DamNotificationService.addNotification(atex.dam.Notification({type: 'error', message: "Error running script : " + e.message}), true);
          }
          if (button.updateContent) {
            var updateInfo = {
              id: response.id,
              data: response.data,
              revision: response.revision
            };

            return ContentService.updateContent(updateInfo).then (function () {
              $rootScope.$broadcast('dam:updatedItem', {'id': id});
            });
          }
        });
        updatePromises.push(promise);
      });

      return $q.all(updatePromises);

      }).then(function (response) {
        DamActivityService.unlock(ids);

        DamNotificationService.addNotification(atex.dam.Notification({
          type: 'success',
          message: $translate.getTranslationTable().__OPERATION_COMPLETED_SUCCESSFULLY__}), false);
      }).then(null, function (error) {
        if (locked) {
          DamActivityService.unlock(ids);
        }
        var message = $scope.translate('__GENERIC_ERROR_MSG__') + " (" + error.cause + ")";
        DamNotificationService.addNotification(atex.dam.Notification({type: 'error', message: message}), true);
      });
  };

  $scope.changeStatus = function() {
    var ids = atex.dam.AngularUtils.getIdsArray($scope.selected);
    if (ids) {
      $scope.presentChangeStatusModal(ids);
    }
  };

  $scope.isEntryNew = function(entry) {
    var searchId = $scope.$parent.damid;
    if (!searchId) {
      return false;
    }
    return DamSearchService.isEntryNew(searchId, entry);
  };

}]);
